import Model from '@/models/Model'

export default class WhPromo extends Model {
    resource() {
        return 'wh_promo'
    }

    toCreate () {
        return this.clean([
            "name",
            "alias_name",
            "description",
            "internal_code",
            "wh_subfamily_id",
            "warranty_days",
            "is_repackaged",
            "is_tax_free",
            "is_consumable",
            "is_seasonal",
            "tags",
            "branch_office_data",
            "upc_codes",
            "products",
        ])
    }
}